import React from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import Show from "./images/romanfigure.png";

const HighlightSection = () => {
  return (
    <Box
      sx={{
        background: {
          xs: `url(${Show}) right bottom no-repeat`,
          md: `url(${Show}) right bottom no-repeat`,
        },
        backgroundSize: { xs: "95%", md: "22%" },
        backgroundPosition: { xs: "right bottom", md: "right" },
        color: "#000",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
        minHeight: { xs: "auto", md: "80vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "flex-start", md: "center" },
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
          mb: 6,
          textAlign: "center",
          backgroundColor: {
            xs: "rgba(255, 255, 255, 0.9)",
            md: "transparent",
          },
          p: { xs: 2, md: 0 },
          borderRadius: { xs: "10px", md: "0" },
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 3,
            lineHeight: 1.3,
            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
            },
          }}
        >
          Почему это работает?
        </Typography>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 400,
            background: "linear-gradient(to right, #7e5f89, #c77792, #cc7472)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: {
              xs: "1.25rem",
              md: "1.5rem",
            },
          }}
        >
          Мой метод доказывает свою эффективность, потому что:
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{
          maxWidth: "900px",
          mt: { xs: -8, md: 0 },
          position: "relative",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: {
              xs: "rgba(255, 255, 255, 0.9)",
              md: "transparent",
            },
            p: { xs: 0, md: 0 },
            borderRadius: { xs: "10px", md: "0" },
          }}
        >
          Каждое решение создаётся под ваш уникальный запрос и текущую ситуацию.
          <List>
            <ListItem
              sx={{
                justifyContent: "left",
                mb: { xs: 1, md: 2 },
                textAlign: "left",
              }}
            >
              <ListItemIcon>
                <VerifiedIcon sx={{ color: "#cc7472" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <Typography
                      component="span"
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      Результативность:
                    </Typography>{" "}
                    Клиенты достигают реальных изменений — от роста бизнеса до
                    глубокой личной трансформации.
                  </>
                }
              />
            </ListItem>
            <ListItem
              sx={{
                justifyContent: "left",
                mb: { xs: 1, md: 2 },
                textAlign: "left",
              }}
            >
              <ListItemIcon>
                <VerifiedIcon sx={{ color: "#cc7472" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <Typography
                      component="span"
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      Индивидуальный подход:
                    </Typography>{" "}
                    Каждое решение адаптируется под вашу уникальную ситуацию и
                    цели.
                  </>
                }
              />
            </ListItem>{" "}
            <ListItem
              sx={{
                justifyContent: "left",
                mb: { xs: 1, md: 2 },
                textAlign: "left",
              }}
            >
              <ListItemIcon>
                <VerifiedIcon sx={{ color: "#cc7472" }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <Typography
                      component="span"
                      sx={{
                        fontWeight: "bold",
                      }}
                    >
                      Опыт и доверие:
                    </Typography>{" "}
                    Более 10 лет управления компаниями и помощь предпринимателям
                    по всему миру.
                  </>
                }
              />
            </ListItem>
          </List>
        </Grid>
      </Grid>
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
          mt: 6,
          textAlign: "center",
          backgroundColor: {
            xs: "rgba(255, 255, 255, 0.9)",
            md: "transparent",
          },
          p: { xs: 2, md: 0 },
          borderRadius: { xs: "10px", md: "0" },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "#000",
            fontWeight: 500,
          }}
        >
          Каждый шаг основан на практике, а не теории, чтобы вы могли быстро
          внедрять решения и видеть результаты.
        </Typography>
      </Box>
    </Box>
  );
};

export default HighlightSection;
